import React from 'react';
import { WorldpayConfirmation } from '../api/payments';

// `worldpayConfirmation` has been typed in payments.ts since the panel was
// first built, but nothing ever rendered it -- staff had no way to see
// whether a phone payment was only staff-confirmed (immediate, but not yet
// independently corroborated), had been verified by Worldpay's own webhook,
// or was recorded purely from the webhook with no staff confirmation at all
// (webhook_only -- worth a second look, since it means the "payment taken"
// step in the design doc's flow never happened on our side). This is
// exactly the state worth watching in the first fortnight after go-live.
const STATUS_LABEL: Record<WorldpayConfirmation['status'], string> = {
  staff_confirmed: 'Worldpay: staff confirmed',
  verified: 'Worldpay: verified',
  webhook_only: 'Worldpay: webhook only',
};

const STATUS_CLASSES: Record<WorldpayConfirmation['status'], string> = {
  staff_confirmed: 'bg-indigo-100 text-indigo-700',
  verified: 'bg-green-100 text-green-700',
  webhook_only: 'bg-amber-100 text-amber-700',
};

interface WorldpayConfirmationBadgeProps {
  confirmation?: WorldpayConfirmation | null;
  className?: string;
}

export const WorldpayConfirmationBadge: React.FC<WorldpayConfirmationBadgeProps> = ({
  confirmation,
  className,
}) => {
  if (!confirmation || !confirmation.status) return null;
  const label = STATUS_LABEL[confirmation.status] || `Worldpay: ${confirmation.status}`;
  const classes = STATUS_CLASSES[confirmation.status] || 'bg-gray-100 text-gray-700';
  const title = confirmation.verifiedAt
    ? `Verified at ${confirmation.verifiedAt}`
    : confirmation.confirmedAt
    ? `Confirmed at ${confirmation.confirmedAt}`
    : undefined;

  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 text-xs font-medium rounded ${classes} ${className || ''}`}
      title={title}
    >
      {label}
    </span>
  );
};

export default WorldpayConfirmationBadge;
